<template>
	<div id="sign_body">
		<navbar :title="title" />
		<van-form @submit="onSubmit">
			<van-field
				v-model="form.sign_remark"
				rows="3"
				autosize
				label="备注"
				type="textarea"
				placeholder="请输入备注"
			/>

			<van-field
				label="位置"
				value="点击获取位置"
				readonly
				@click="getLocation"
				v-model="form.sign_address"
			/>

			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="form.uploader" :max-count="3" accept="image/*" capture="camera" />
					<!-- 修改为只允许拍照不允许本地上传 -->
				</template>
			</van-field>

			<van-field
				v-model="client_text"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.client = true"
				:rules="[
					{
						required: true,
						trigger: 'onBlur',
						message: '请选择关联客户',
					},
				]"
			/>
			<van-field label="拜访地址" readonly v-model="form.client_address" />

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-tabbar v-model="activeName">
			<van-tabbar-item name="sign" icon="location-o" to="/sign">签到</van-tabbar-item>
			<van-tabbar-item name="list" icon="label-o" to="/sign/list">记录</van-tabbar-item>
		</van-tabbar>

		<van-popup
			v-model="popup.client"
			position="right"
			:style="{ width: '60%', height: '100%' }"
		>
			<popup-select
				v-model="clientList.list"
				@onload="onloadClient"
				@check="checkClient"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>

		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>

		<div>{{ mes }}</div>
	</div>
</template>

<script>
import popupselect from "@/components/select/index";
import navbar from "@/components/navBar/index";
import { getDetailed } from "@/api/map";
import { post } from "@/api/dispatch";
import { Toast, Dialog } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";

export default {
	name: "sign",
	components: {
		navbar,
		"popup-select": popupselect,
	},
	data() {
		return {
			title: "签到",
			localIndex: 0,
			key: "T7GBZ-Z2PR3-FU53J-YAAEX-EYJN2-FUFWU",
			form: {
				sign_remark: "",
				longitude: 0, //经度
				latitude: 0, //纬度
				sign_address: "点击获取位置",
				client_id: "",
				client_address: "",
				uploader: [],
			},
			activeName: "sign",
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25,
			},
			popup: {
				client: false,
			},
			client_text: "",
			signTime: true,
			geolocation: "",
			mes: "",
			locationTimeOut: true, // 判断是否长时间为获取地址信息
		};
	},
	methods: {
		onSubmit() {
			let that = this;

			console.log(this.form);
			if (!this.form.sign_remark) {
				return this.$toast.fail("请输入备注");
			}
			if (
				this.form.sign_address === "点击获取位置" ||
				this.form.sign_address === "获取位置失败,请点击重试!"
			) {
				return this.$toast.fail("请输入先获取位置");
			}
			if (this.form.uploader.length === 0) {
				return this.$toast.fail("请上传附件");
			}

			this.form.requestType = "visit_save";
			let formData = new FormData();
			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("sign_remark", this.form.sign_remark);
			formData.append("longitude", this.form.longitude);
			formData.append("latitude", this.form.latitude);
			formData.append("sign_address", this.form.sign_address);
			formData.append("client_id", this.form.client_id);
			formData.append("requestType", "visit_save");
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;
			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then(function(res) {
					that.signTime = true;
					if (res.status === 200) {
						Toast.fail("签到成功!");
						that.form.sign_remark = "";
						that.form.longitude = 0;
						that.form.latitude = 0;
						that.client_text = "";
						that.form.client_id = "";
						that.form.client_address = "";
						that.form.sign_address = "点击获取位置";
						that.form.uploader = [];
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		getLocation() {
			let geolocation = new qq.maps.Geolocation(this.key, "myapp"); // eslint-disable-line
			this.getLocationTimeOut();
			this.$toast.loading("正在获取");
			try {
				geolocation.getLocation(this.showPosition, this.showErr);
			} catch (error) {
				this.locationTimeOut = false;
				this.$toast.loading("获取失败");
			}
		},
		showPosition(position) {
			this.locationTimeOut = false;
			this.latitude = position.lat;
			this.longitude = position.lng;

			getDetailed({
				requestType: "visit_sign_positioning",
				longitude: this.longitude,
				latitude: this.latitude,
			})
				.then((response) => {
					this.$toast.success("获取成功");
					this.form.sign_address = response.obj.result.address;
				})
				.catch(() => {
					this.$toast.fail("服务器发生错误");
				});
		},
		getLocationTimeOut() {
			setTimeout(() => {
				if (this.locationTimeOut) {
					Dialog.alert({
						title: "定位失败",
						message: "如果您网路无问题,请打开app设置,开启定位权限",
					});
				}
			}, 20 * 1000);
		},
		showErr() {
			this.$toast.fail("获取失败");
			if (this.localIndex === 0) {
				this.localIndex += 1;
				this.getLocation();
			} else {
				this.local = "获取位置失败,请点击重试!";
			}
		},
		onloadClient(search) {
			if (search != undefined) {
				this.clientList.page = 1;
			}
			post({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search,
			})
				.then((res) => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(res.obj.rows);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch((err) => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return this.$toast.fail("数据异常");
				});
		},
		checkClient(value) {
			console.log(value);
			this.form.client_address = value.address;
			this.popup.client = false;
			this.client_text = value.client_name;
			this.form.client_id = value.client_id;
		},
	},
};
</script>

<style lang="scss">
#sign_body {
	.wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.van-loading__text {
		color: #ffffff;
	}
}
</style>
